import { UsageTrackerProvider } from 'personalization-lib/contexts/UsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
const withUsageTracking = WrappedComponent => props => /*#__PURE__*/_jsx(UsageTrackerProvider, {
  trackerProps: props.trackerProps,
  children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
});
export default withUsageTracking;